import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Box,
    Button,
    Typography,
    Container,
    Card,
    IconButton,
    Grid,
    Fade,
    Zoom
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { baseUrl } from "../lib/constant";

const GuidePdfPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { pdfData, error, templateId, lashSize } = location.state || {};

    useEffect(() => {
        if (!location.state) {
            navigate("/");
        }
    }, [location.state, navigate]);

    const pdfUrl = pdfData?.data?.pdf_uploaded ? `${baseUrl}/${pdfData.data.pdf_uploaded}` : null;

    const handleBack = () => navigate(-1);
    const handleNext = () => {
        navigate("/add-product");
    };

    const handleFullScreenView = () => {
        if (pdfUrl) {
            window.open(pdfUrl, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <Container maxWidth="md" sx={{ py: 6 }}>
            <Fade in timeout={600}>
                <Card
                    sx={{
                        background: "linear-gradient(145deg, #ffffff, #f9e6ea)",
                        p: { xs: 3, sm: 4 },
                        borderRadius: 3,
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
                        transition: "transform 0.3s ease-in-out",
                        "&:hover": { transform: "translateY(-4px)" }
                    }}
                >
                    {!pdfData || error ? (
                        <Zoom in timeout={800}>
                            <Box sx={{ textAlign: "center", py: 4 }}>
                                <ErrorOutlineIcon
                                    sx={{
                                        fontSize: { xs: 60, sm: 80 },
                                        color: "#d32f2f",
                                        mb: 2,
                                        animation: "pulse 2s infinite",
                                        "@keyframes pulse": {
                                            "0%": { transform: "scale(1)" },
                                            "50%": { transform: "scale(1.1)" },
                                            "100%": { transform: "scale(1)" }
                                        }
                                    }}
                                />
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontWeight: 700,
                                        color: "#d32f2f",
                                        mb: 1,
                                        fontSize: { xs: "1.5rem", sm: "2rem" }
                                    }}
                                >
                                    Guide Pdf  Not Found
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: "#555",
                                        mb: 3,
                                        maxWidth: 500,
                                        mx: "auto",
                                        fontSize: { xs: "0.9rem", sm: "1rem" }
                                    }}
                                >
                                    We're sorry, but no guide pdf could be found for this template and size combination. Please try again or contact support.
                                </Typography>
                                <Box sx={{ display: "flex", justifyContent: "center", gap: 2, flexWrap: "wrap" }}>
                                    <Button
                                        variant="outlined"
                                        onClick={handleBack}
                                        sx={{
                                            borderColor: "#B1727C",
                                            color: "#B1727C",
                                            fontWeight: 600,
                                            px: 3,
                                            py: 1,
                                            borderRadius: 2,
                                            "&:hover": {
                                                borderColor: "#B1727C",
                                                backgroundColor: "#ffebee"
                                            }
                                        }}
                                    >
                                        Go Back
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        sx={{
                                            fontWeight: 600,
                                            px: 3,
                                            py: 1,
                                            borderRadius: 2,
                                            backgroundColor: "#B1727C",
                                            "&:hover": { backgroundColor: "#B1727C" }
                                        }}
                                    >
                                        Contact Admin
                                    </Button>
                                </Box>
                            </Box>
                        </Zoom>
                    ) : (
                        <>
                            <Grid container alignItems="center" justifyContent="space-between" mb={3}>
                                <Grid item xs={12} sm={8}>
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#6d2e46",
                                            mb: 1,
                                            fontSize: { xs: "1.25rem", sm: "1.5rem" }
                                        }}
                                    >
                                        Template: <strong>{pdfData.data.template_name}</strong>
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            fontWeight: 500,
                                            color: "#6d2e46",
                                            fontSize: { xs: "0.9rem", sm: "1rem" }
                                        }}
                                    >
                                        Size: <strong>{lashSize}</strong>
                                    </Typography>
                                </Grid>
                                {/* <Grid item>
                                    <IconButton
                                        onClick={handleFullScreenView}
                                        aria-label="View Fullscreen"
                                        sx={{
                                            color: "#6d2e46",
                                            "&:hover": { backgroundColor: "#f9e6ea" }
                                        }}
                                    >
                                        <FullscreenIcon sx={{ fontSize: { xs: 28, sm: 32 } }} />
                                    </IconButton>
                                </Grid> */}
                            </Grid>

                            <Typography
                                variant="subtitle1"
                                sx={{
                                    fontWeight: 500,
                                    color: "#6d2e46",
                                    mb: 3,
                                    fontSize: { xs: "0.9rem", sm: "1rem" }
                                }}
                            >
                                Guide Pdf: <strong>{pdfData.data.guide_name}</strong>
                            </Typography>

                            <Box
                                sx={{
                                   
                                    height: { xs: "0px", sm: "0px" },
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: "#fff",
                                    borderRadius: 2,
                                    overflow: "hidden",
                                    mb: 3,
                                    boxShadow: "inset 0 2px 8px rgba(0, 0, 0, 0.05)"
                                }}
                            >
                                <iframe
                                    src={pdfUrl}
                                    title="Guide PDF"
                                    width="0%"
                                    height="0%"
                                    style={{ border: "none" }}
                                    aria-label="PDF preview of the guide"
                                />
                            </Box>

                            <Box textAlign="center">
                                <Button
                                    variant="contained"
                                    onClick={handleNext}
                                    sx={{
                                        backgroundColor: "#B1727C",
                                        color: "#fff",
                                        fontWeight: 600,
                                        px: 4,
                                        py: 1.5,
                                        borderRadius: 2,
                                        "&:hover": {
                                            backgroundColor: "#B1727C",
                                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)"
                                        },
                                        transition: "all 0.3s ease"
                                    }}
                                >
                                    Next
                                </Button>
                            </Box>
                        </>
                    )}
                </Card>
            </Fade>
        </Container>
    );
};

export default GuidePdfPage;